import {BaseEntityConfig, WhiteListFields} from '~/redux/base-entity-config';
import {TestimonialEntity} from '~/types/models/testimonial';

class EntityConfig extends BaseEntityConfig<TestimonialEntity> {
  entityKey = 'testimonials';

  associates = [];

  whiteListFields: WhiteListFields<TestimonialEntity> = ['*'];

  getAccessors = (value: TestimonialEntity) => {
    //
  };
}

const testimonialEntConf = new EntityConfig();

export const testimonialSchema = testimonialEntConf.getEntitySchema();

export default testimonialEntConf;

export const SOURCES_TESTIMONIAL = {
  TESTIMONIALS_PAGE: 'TESTIMONIALS_PAGE',
};
